export default [
	{
		path: '/login',
		name: 'login',
		meta: {
			title: "登录",
			login:false
		},
		component: () => import("@/views/login/Login")
	},
	{
		path: '/register',
		name: 'register',
		meta: {
			title: "注册",
			login:false
		},
		component: () => import("@/views/login/Register")
	}
]